import { useMessageToState } from "./useMessageToState";

const getProductVariantCode = (editor: eXpress.core.IEditor) =>
	editor.definition
		? new eXpress.core.ProductVariant(
				editor.definition?.product.code,
				editor.definition?.selectedAttributeCode,
				editor.definition?.product.aspectRatio,
		  ).code
		: undefined;

/** Returns the current productVariant */
export function useProductVariantCode() {
	return useMessageToState({
		name: "useProductVariantCode",
		filterMessage: (message) =>
			eXpress.core.isProductCodeChanged(message) ||
			eXpress.core.isAttributeChanged(message) ||
			eXpress.core.isAspectRatioChanged(message),
		getState: getProductVariantCode,
	});
}
